import React from 'react';
import PropTypes from 'prop-types';

import MetaDataMarkup from 'components/MetaDataMarkup';
import { gmConfig } from 'helpers/config';
import buildPageAnalytics from 'helpers/buildPageAnalytics';
import { LOGO_IMAGE } from 'constants/Logos';
import { GUARANTEE_PAGE_NAME } from 'constants/pageNames';
import { getFaqCategories } from 'api/faqContent';
import GuaranteePageView from 'views/GuaranteePage';
import configureStore from 'state/configureStore';
import getServerSidePropsWrapper from 'helpers/getServerSidePropsWrapper';

const SITE_NAME = 'The Bash';
const TITLE = 'The Bash Booking Guarantee';
const DESCRIPTION =
  'Every booking on The Bash is automatically covered by our Guarantee - Customer Support, Payment Security and Vendor Accountability at no extra charge.';

export const FAQ_ENTRIES = [
  '3kFIdzsLGTrr1vvJkMKjCW',
  '4ZBBGPHIpWJZhxI0DtEpeD',
  '1RiyOL6WAWEenDXpFwt1bt',
  '1GJssx195YcedK8KXa8Mzu',
  '2zQv79vSdHUdNbMiACJgm',
];

export const FAQ_ENTRIES_ORDER = {
  '3kFIdzsLGTrr1vvJkMKjCW': 0,
  '4ZBBGPHIpWJZhxI0DtEpeD': 1,
  '1RiyOL6WAWEenDXpFwt1bt': 2,
  '1GJssx195YcedK8KXa8Mzu': 3,
  '2zQv79vSdHUdNbMiACJgm': 4,
};

export const GuaranteePage = ({ faqEntries }) => (
  <>
    <MetaDataMarkup
      title={TITLE}
      description={DESCRIPTION}
      openGraphProps={{
        title: TITLE,
        description: DESCRIPTION,
        type: 'website',
        url: `https://${gmConfig.domains.www}/guarantee`,
        image: LOGO_IMAGE,
        site_name: SITE_NAME,
      }}
    />
    <GuaranteePageView faqEntries={faqEntries} />
  </>
);

export const handleServerSideProps = async () => {
  const pageAnalytics = buildPageAnalytics(GUARANTEE_PAGE_NAME);
  let faqCategories = [];
  try {
    faqCategories = await getFaqCategories();
  } catch (err) {
    // Not raising an error since most of the page can function without FAQs
    console.error(err);
  }

  const faqEntries = faqCategories
    .reduce((entries, category) => {
      let newEntries = [...entries];
      category.faqGroups.forEach((fg) => {
        newEntries = newEntries.concat(
          fg.faqEntries.map((fe) => ({ ...fe, category: category.category, group: fg.group }))
        );
      });

      return newEntries;
    }, [])
    .filter((fe) => FAQ_ENTRIES.includes(fe.id))
    .sort((a, b) => FAQ_ENTRIES_ORDER[a.id] - FAQ_ENTRIES_ORDER[b.id]);

  return {
    ...pageAnalytics,
    faqEntries,
    errorCode: null,
  };
};

export const getServerSideProps = configureStore.getServerSideProps(
  (store) => async (ctx) =>
    await getServerSidePropsWrapper({ ...ctx, store }, handleServerSideProps)
);

GuaranteePage.propTypes = {
  faqEntries: PropTypes.array.isRequired,
};

export default GuaranteePage;
